import { today, ajaxFileRequest } from "@utils/helpers";
import type { VaultMessage } from "./types";

let hasInitialized = false;

export function initializeVaultBridge(): void {

    if (hasInitialized) {
        return;
    }
    hasInitialized = true;


    const exclude = ['/admin'];
    if (exclude.some((path) => window.location.pathname.startsWith(path))) {
        return;
    }

    if (typeof window.chrome === 'undefined' || !window.chrome.runtime) {
        return;
    }

    let port: any;
    const extensionId = 'mnkjojkkflemmfphpefojghbijildbck';

    const connect = () => {
        port = window.chrome.runtime.connect(extensionId);

        if (!port) {
            return;
        }

        port.onDisconnect.addListener(() => {
            port = null;

            if (window.chrome.runtime.lastError) {
                return;
            }

            connect();
        });

        port.onMessage.addListener((response: VaultMessage) => {
            const dateToday = today();

            if (response.action !== 'check-update') {
                return;
            }

            if (response.needsDrugLog) {
                ajaxFileRequest(`/api/medical/drug-log/${dateToday}/patients/excel`, (blob, fileName) => {
                    if (!fileName) {
                        return;
                    }

                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = () => {
                        port?.postMessage({
                            drugLog: reader.result
                        });
                    };
                });
            }

            if (response.lastRosterDate !== dateToday) {
                ajaxFileRequest('/api/checkout/roster?includeServices=true', (blob) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = () => {
                        port?.postMessage({
                            roster: reader.result,
                            rosterDate: dateToday
                        });
                    };
                });
            }
        });
    };

    try {
        connect();
    } catch (error) {
        console.debug('extension not found', error);
    }
}
